import React, { Fragment } from 'react';
import {
    Dialog,
    Button,
    IconButton,
    Divider,
    makeStyles,
    Box,
    Card,
    CardContent,
    CardHeader,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { IEnchancedModal } from './types';

const useStyles = makeStyles(() => ({
    root: {},
    container: {
        overflow: 'scroll',
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));

/**
 * A reusable modal dialog component
 *
 * @param {string} title- sets dialogTitle string
 * @param {boolean} open - Controls whether the modal is open or closed.
 * @param {Function} setOpen - Function to update the open state, used to open or close the modal.
 * @param {ReactNode} children - The content to be displayed inside the modal.
 * @param {string} [buttonText] - Optional text for a button that will trigger the modal to open. If not provided, no button will be rendered.
 * @param {Breakpoint} [maxWidth] - Optional maxWidht param. Default is xs.
 **/
export const EnchancedModal = ({
    title,
    open,
    setOpen,
    buttonText,
    children,
    buttonProps = {},
    maxWidth = 'xs',
    ...props
}: IEnchancedModal) => {
    const classes = useStyles();

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    return (
        <Fragment>
            {buttonText && (
                <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    fullWidth
                    onClick={handleOpen}
                    {...buttonProps}
                >
                    {buttonText}
                </Button>
            )}

            <Dialog
                maxWidth={maxWidth}
                fullWidth
                onClose={handleClose}
                open={open}
                {...props}
            >
                <Card className={classes.container}>
                    <Box className={classes.title}>
                        {title && (
                            <CardHeader
                                variant="h5"
                                color="textPrimary"
                                title={title}
                            />
                        )}
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Divider />
                    <CardContent>{children}</CardContent>
                </Card>
            </Dialog>
        </Fragment>
    );
};
